import { hashName, sanitizeFilename } from "@/helpers/general";
import MediaService from "./mediaService";

const getFilesData = ({ files }) => {
  const hashNames = {};

  const filesData = Object.keys(files)
    .map((prop) => {
      const file = files[prop];

      if (!file) {
        console.warn(`File for property ${prop} is undefined or null`);
        return null;
      }

      // Pasamos el prop (clave del campo) al hashName para la unicidad
      const hash = hashName({ file, fileKey: prop });

      hashNames[file.name] = hash;

      return {
        prop,
        hash,
      };
    })
    .filter(Boolean); // Eliminamos cualquier entrada nula que pudiera generarse

  // Retornamos tanto los metadatos como el objeto hashNames
  return { filesData, hashNames };
};

const RegisterService = {
  url: `${process.env.VUE_APP_API_URL}register`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },

  step1: async (data) => {
    try {
      const response = await fetch(`${RegisterService.url}/step-1`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: RegisterService.headers,
      });

      return response;
    } catch (e) {
      console.error(e);
      return false;
    }
  },

  step2: async (data) => {
    try {
      const headers = RegisterService.headers;
      // headers['Register_Token'] = localStorage.getItem('register_token')
      data["register_token"] = localStorage.getItem("register_token");

      const response = await fetch(`${RegisterService.url}/step-2`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: headers,
      });

      return response;
    } catch (e) {
      return false;
    }
  },

  step5: async (data) => {
    try {
      const headers = RegisterService.headers;
      // headers['Register_Token'] = localStorage.getItem('register_token')
      data["register_token"] = localStorage.getItem("register_token");

      const response = await fetch(`${RegisterService.url}/step-5`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: headers,
      });

      return response;
    } catch (e) {
      return false;
    }
  },
  step6CompanyInfo: async ({ files }) => {
    try {
      // Validamos que hay archivos para procesar
      if (!files || Object.keys(files).length === 0) {
        throw new Error("No se proporcionaron archivos para subir");
      }

      const register_token = localStorage.getItem("register_token");
      if (!register_token) {
        throw new Error("No se encontró el token de registro");
      }

      // Configuramos los headers correctamente
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Register_Token", register_token);

      // Creamos un nuevo objeto para almacenar los archivos procesados
      const processedFiles = {};

      // recorremos todos los archivos renombrandolos sanitizando el nombre
      // y agregando el indice al final
      Object.keys(files).forEach((key, index) => {
        const file = files[key];

        if (!file) {
          console.warn(`File for property ${key} is undefined or null`);
          return;
        }

        // Sanitizamos el nombre del archivo
        let sanitizedName = sanitizeFilename(file.name);

        // Renombramos el archivo nombre + indice + extension
        const nameParts = sanitizedName.split(".");
        const extension = nameParts.length > 1 ? nameParts.pop() : "unknown";
        const baseName = nameParts.join(".");
        const newName = `${baseName}_${index}.${extension}`;

        // Creamos un nuevo objeto File con el nuevo nombre
        processedFiles[key] = new File([file], newName, { type: file.type });
      });

      // Generamos los metadatos de archivos y el mapa de hash
      const { filesData, hashNames } = getFilesData({ files: processedFiles });

      if (!filesData || filesData.length === 0) {
        throw new Error("No se pudo procesar la información de los archivos");
      }

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ filesData, register_token }),
        redirect: "follow",
      };

      // Primero registramos los metadatos
      const response = await fetch(
        `${RegisterService.url}/step-6-general-info`,
        requestOptions
      );
      const status = response.status;

      if (status !== 200) {
        const errorText = await response.text();
        throw new Error(`Error al registrar metadatos: ${errorText}`);
      }

      const data = await response.json();
      const { customer_id } = data;

      if (!customer_id) {
        throw new Error("No se recibió el ID del cliente desde el servidor");
      }

      // Luego subimos los archivos físicos
      await MediaService.uploadFiles({
        files: processedFiles,
        register_token,
        customer_id,
        hashNames,
      });

      return {
        data,
        status,
      };
    } catch (error) {
      console.error("Error en step6CompanyInfo:", error);
      // Devolvemos un objeto similar al de éxito pero con información del error
      return {
        data: { error: error.message },
        status: 500,
      };
    }
  },
  step6BankStatments: async ({ files }) => {
    try {
      // Validamos que hay archivos para procesar
      if (!files || Object.keys(files).length === 0) {
        throw new Error("No se proporcionaron archivos para subir");
      }

      const register_token = localStorage.getItem("register_token");

      if (!register_token) {
        throw new Error("No se encontró el token de registro");
      }

      // Configuramos los headers correctamente
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Register_Token", register_token);

      // Creamos un nuevo objeto para almacenar los archivos procesados
      const processedFiles = {};

      // recorremos todos los archivos renombrandolos sanitizando el nombre
      // y agregando el indice al final
      Object.keys(files).forEach((key, index) => {
        const file = files[key];

        if (!file) {
          console.warn(`File for property ${key} is undefined or null`);
          return;
        }

        // Sanitizamos el nombre del archivo
        let sanitizedName = sanitizeFilename(file.name);

        // Renombramos el archivo nombre + indice + extension
        const nameParts = sanitizedName.split(".");
        const extension = nameParts.length > 1 ? nameParts.pop() : "unknown";
        const baseName = nameParts.join(".");
        const newName = `${baseName}_${index}.${extension}`;

        // Creamos un nuevo objeto File con el nuevo nombre
        processedFiles[key] = new File([file], newName, { type: file.type });
      });

      // Generamos los metadatos de archivos y el mapa de hash
      const { filesData, hashNames } = getFilesData({ files: processedFiles });

      if (!filesData || filesData.length === 0) {
        throw new Error("No se pudo procesar la información de los archivos");
      }

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ filesData, register_token }),
        redirect: "follow",
      };

      // Primero registramos los metadatos
      const response = await fetch(
        `${RegisterService.url}/step-6-bank-statements`,
        requestOptions
      );
      const status = response.status;

      if (status !== 200) {
        const errorText = await response.text();
        throw new Error(
          `Error al registrar metadatos de estados bancarios: ${errorText}`
        );
      }

      const data = await response.json();
      const { customer_id } = data;

      if (!customer_id) {
        throw new Error("No se recibió el ID del cliente desde el servidor");
      }

      // Luego subimos los archivos físicos
      await MediaService.uploadFiles({
        files: processedFiles,
        register_token,
        customer_id,
        hashNames,
      });

      return {
        data,
        status,
      };
    } catch (error) {
      console.error("Error en step6BankStatments:", error);
      return {
        data: { error: error.message },
        status: 500,
      };
    }
  },
};

export default RegisterService;
